import * as yup from "yup";
import { Message } from "yup/lib/types";

export const formResolver = (t: (arg: string) => Message) => {
  return yup.object().shape({
    companyName: yup.string().nullable().required(t("validation.required")),
    fullCompanyName: yup.string().nullable().required(t("validation.required")),
    inn: yup.string().nullable().required(t("validation.required")),
    kpp: yup.string().nullable().required(t("validation.required")),
    ogrn: yup.string().nullable().required(t("validation.required")),
    legalAddress: yup.string().nullable().required(t("validation.required")),
    postalAddress: yup.string().nullable().required(t("validation.required")),
    paymentAccount: yup.string().nullable().required(t("validation.required")),
    bankName: yup.string().nullable().required(t("validation.required")),
    correspondentAccount: yup
      .string()
      .nullable()
      .required(t("validation.required")),
    bik: yup.string().nullable().required(t("validation.required")),
    phone: yup.string().nullable().required(t("validation.required")),
    fax: yup.string().nullable().required(t("validation.required")),
    okved: yup.string().nullable().required(t("validation.required")),
    email: yup.string().nullable().required(t("validation.required")),
    ogrn_date: yup.date().nullable().required(t("validation.required")),
    ogrn_number: yup.string().nullable().required(t("validation.required")),
  });
};
